module.exports = __webpack_public_path__ + "static/media/incomingorder.6cf8dbd6.WAV";